// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__zfhso","sidebar__link":"Sidebar_sidebar__link__88E7+","active__link":"Sidebar_active__link__FZdWy"};